import { createRouter, createWebHistory } from 'vue-router';

import AssessmentIndex from '@/manager/views/AssessmentIndex.vue';
import AssessmentShow from '@/manager/views/AssessmentShow.vue';
import AttendanceIndex from '@/manager/views/AttendanceIndex.vue';
import BillingCenterIndex from '@/manager/views/BillingCenterIndex.vue';
import BusinessShow from '@/manager/views/BusinessShow.vue';
import CodeSent from '@/shared/views/CodeSent.vue';
import ContactSubscriptions from '@/shared/views/ContactSubscriptions.vue';
import CourseIndex from '@/manager/views/CourseIndex.vue';
import CourseShow from '@/manager/views/CourseShow.vue';
import DocumentIndex from '@/manager/views/DocumentIndex.vue';
import EnrollmentIndex from '@/manager/views/EnrollmentIndex.vue';
import FallbackRouter from '@/shared/views/FallbackRouter.vue';
import FormNew from '@/manager/views/forms/FormNew.vue';
import FormRequestIndex from '@/manager/views/forms/FormRequestIndex.vue';
import GrantNew from '@/manager/views/grants/GrantNew.vue';
import GrantProgramIndex from '@/manager/views/grants/GrantProgramIndex.vue';
import GrantProgramShow from '@/manager/views/grants/GrantProgramShow.vue';
import InterestedIndex from '@/manager/views/InterestedIndex.vue';
import LessonQuiz from '@/manager/views/LessonQuiz.vue';
import LessonShow from '@/manager/views/LessonShow.vue';
import LicenseFormNew from '@/manager/views/licenses/LicenseFormNew.vue';
import LicenseShow from '@/manager/views/licenses/LicenseShow.vue';
import LoginCodes from '@/shared/components/LoginCodes.vue';
import ManagerAccount from '@/manager/views/managers/ManagerAccount.vue';
import ManagerDashboard from '@/manager/views/managers/ManagerDashboard.vue';
import ManagerLandingDashboard from '@/manager/views/managers/ManagerLandingDashboard.vue';
import ManagerProfile from '@/manager/views/managers/ManagerProfile.vue';
import ManagerWelcome from '@/manager/views/managers/ManagerWelcome.vue';
import MassMessageIndex from '@/manager/views/MassMessageIndex.vue';
import MessageIndex from '@/manager/views/MessageIndex.vue';
import OnboardingForm from '@/manager/views/OnboardingForm.vue';
import ProviderIndex from '@/manager/views/ProviderIndex.vue';
import ProviderLicenseIndex from '@/manager/views/ProviderLicenseIndex.vue';
import ProviderShow from '@/manager/views/ProviderShow.vue';
import ProviderStaffIndex from '@/shared/components/provider/ProviderStaffIndex.vue';
import ProviderStaffShow from '@/shared/views/provider/ProviderStaffShow.vue';
import PublicProviderShow from '@/public/views/ProviderShow.vue';
import RegisterAccess from '@/manager/views/RegisterAccess.vue';
import RegisterFactor from '@/shared/views/RegisterFactor.vue';
import RegisterName from '@/manager/views/RegisterName.vue';
import RegisterPassword from '@/shared/views/RegisterPassword.vue';
import SignOut from '@/shared/views/SignOut.vue';
import store from '@/manager/store';
import StudentIndex from '@/manager/views/StudentIndex.vue';
import TermsAgreement from '@/manager/views/TermsAgreementShow.vue';
import TourShow from '@/manager/views/TourShow.vue';
import WebpageLanding from '@/shared/views/WebpageLanding.vue';
import WebpageShow from '@/shared/views/WebpageShow.vue';
import WorkflowInstanceShow from '@/manager/views/WorkflowInstanceShow.vue';

export const routes = [
  {
    component: AssessmentIndex,
    name: 'AssessmentIndex',
    path: '/assessments',
    meta: {
      depth: 2,
      title: 'QRIS',
    },
  },

  {
    component: RegisterAccess,
    name: 'RegisterAccess',
    path: '/access',
    meta: {
      depth: 2,
      title: 'Join your organization',
    },
    beforeEnter(_to, _from, next) {
      !store.getters.isEmployed() ? next() : next('/');
    },
  },

  {
    component: RegisterFactor,
    name: 'RegisterFactor',
    path: '/mfa',
    meta: {
      depth: 2,
      registration: true,
      title: 'Register MFA',
    },
  },

  {
    component: RegisterName,
    name: 'RegisterName',
    path: '/register',
    meta: {
      depth: 2,
      registration: true,
      title: 'RegisterName',
    },
  },

  {
    component: RegisterPassword,
    name: 'RegisterPassword',
    path: '/password',
    meta: {
      depth: 2,
      registration: true,
      title: 'Set password',
    },
  },

  {
    component: OnboardingForm,
    name: 'OnboardingForm',
    path: '/onboarding/:schemaId',
    meta: {
      depth: 3,
      registration: true,
      title: 'Onboarding',
    },
  },

  {
    component: AssessmentShow,
    name: 'AssessmentShow',
    path: '/assessments/:assessmentId/edit',
    meta: {
      depth: 3,
    },
  },

  {
    component: BillingCenterIndex,
    name: 'BillingCenterIndex',
    path: '/billing_center',
  },

  {
    component: ProviderLicenseIndex,
    name: 'ProviderLicenseIndex',
    path: '/licenses',
    meta: {
      depth: 2,
      title: 'Licenses',
    },
    beforeEnter(_to, _from, next) {
      store.state.features.enable_provider_licenses
        ? next()
        : next(store.getters.defaultLandingPage());
    },
  },

  {
    component: LicenseShow,
    name: 'LicenseShow',
    path: '/licenses/:id',
    meta: {
      depth: 3,
    },
    beforeEnter(_to, _from, next) {
      store.state.features.enable_provider_licenses
        ? next()
        : next(store.getters.defaultLandingPage());
    },
  },

  {
    component: LicenseFormNew,
    name: 'LicenseFormNew',
    path: '/licenses/:licenseId/forms/:formId',
    meta: {
      depth: 3,
    },
    beforeEnter(_to, _from, next) {
      store.state.features.enable_provider_licenses
        ? next()
        : next(store.getters.defaultLandingPage());
    },
  },

  {
    component: CodeSent,
    meta: { background: 'bg-super-light-blue', public: true },
    name: 'CodeSent',
    path: '/code_sent',
    props: (route) => ({ routeParams: route.params, routeQuery: route.query }),
  },

  {
    component: CourseIndex,
    name: 'CourseIndex',
    path: '/courses',
    meta: {
      depth: 2,
      page: 'provider/pages/learning',
      title: 'Learning',
    },
  },

  {
    component: CourseShow,
    name: 'CourseShow',
    path: '/courses/:courseId',
    meta: {
      depth: 3,
      title: 'Learning',
    },
  },

  {
    component: DocumentIndex,
    name: 'DocumentIndex',
    path: '/documents',
    meta: {
      depth: 2,
      title: 'Documents',
    },
  },

  {
    component: GrantProgramIndex,
    name: 'GrantProgramIndex',
    path: '/grants',
    meta: {
      depth: 2,
      page: 'provider/pages/grants',
      title: 'Grants',
    },
  },

  {
    component: GrantNew,
    name: 'GrantNew',
    path: '/grants/:grantId/new',
    meta: {
      depth: 3,
      hideSideNav: true,
    },
  },

  {
    component: GrantProgramShow,
    name: 'GrantProgramShow',
    path: '/grants/:grantProgramId/manage',
    meta: {
      depth: 3,
      hideSideNav: true,
    },
  },

  {
    component: FormNew,
    name: 'FormNew',
    path: '/providers/:providerId/forms/:schemaId',
    meta: {
      depth: 4,
    },
  },

  {
    component: FormNew,
    name: 'WorkflowTaskFormShow',
    path: '/workflow_tasks/:workflowTaskId/form',
    meta: {
      depth: 3,
    },
  },

  {
    component: FormRequestIndex,
    name: 'FormRequestIndex',
    path: '/providers/requests',
    meta: {
      depth: 2,
      page: 'provider/pages/forms',
      title: 'Requests',
    },
    beforeEnter(to, from, next) {
      store.getters.hasProviderRequestableFormSchemas() ? next() : next('/');
    },
  },

  {
    component: InterestedIndex,
    name: 'InterestedIndex',
    path: '/interested',
    meta: {
      depth: 2,
      title: 'Interested',
    },
  },

  {
    path: '/interested/list',
    redirect: '/interested',
  },

  {
    component: LessonShow,
    name: 'LessonShow',
    path: '/courses/:courseId/lessons/:lessonId',
    meta: {
      depth: 4,
      title: 'Continue',
    },
  },

  {
    component: LessonQuiz,
    name: 'LessonQuiz',
    path: '/lesson_completion/:lessonCompletionId/quizzes/:quizSchemaId',
    meta: {
      depth: 5,
      title: 'Quiz',
    },
  },

  {
    component: ManagerAccount,
    meta: {
      depth: 3,
      page: 'provider/pages/member-account',
    },
    name: 'ManagerAccount',
    path: '/member/account',
  },

  {
    component: ManagerDashboard,
    name: 'Dashboard',
    path: '/dashboard',
    meta: {
      depth: 1,
      page: 'provider/introduction',
    },
  },

  {
    component: ManagerLandingDashboard,
    name: 'ProviderLanding',
    path: '/home',
    meta: {
      depth: 1,
      title: 'Home',
    },
    beforeEnter(_to, _from, next) {
      store.getters.isEmployed() ? next(store.getters.defaultLandingPage()) : next();
    },
  },

  {
    component: ManagerProfile,
    meta: { depth: 3 },
    name: 'Profile',
    path: '/member/profile',
  },

  {
    component: ManagerWelcome,
    name: 'Welcome',
    path: '/welcome',
    meta: {
      depth: 1,
      public: true,
      registration: true,
      title: 'Welcome',
    },
  },

  {
    component: MassMessageIndex,
    name: 'MassMessageIndex',
    path: '/mass_messages',
    meta: {
      depth: 2,
      page: 'provider/pages/mass',
      title: 'Mass messages',
    },
  },

  {
    component: MessageIndex,
    name: 'MessageIndex',
    path: '/messages',
    meta: {
      depth: 2,
      page: 'provider/pages/messages',
      title: 'Messages',
    },
  },

  {
    component: WorkflowInstanceShow,
    name: 'WorkflowInstanceShow',
    path: '/workflow-instances/:workflowInstanceId',
    meta: {
      depth: 3,
    },
  },

  {
    component: ProviderIndex,
    name: 'ProviderIndex',
    path: '/providers/list',
    meta: {
      depth: 2,
      page: 'provider/pages/locations',
      title: 'My locations',
    },
    beforeEnter(_to, _from, next) {
      store.state.pages.Provider.enabled ? next() : next('/');
    },
  },

  {
    component: ProviderShow,
    name: 'ProviderShow',
    path: '/providers/:providerId/edit',
    meta: {
      depth: 3,
      page: 'provider/pages/locations',
    },
  },

  {
    path: '/documentation/:pathMatch(.*)?',
    redirect: { name: 'Landing' },
  },

  {
    path: '/manager',
    redirect: '/welcome',
  },

  {
    component: LoginCodes,
    meta: { depth: 1, public: true, title: 'Login' },
    name: 'LoginCode',
    path: '/login_codes/:login_code',
  },

  {
    component: PublicProviderShow,
    meta: { depth: 2, public: true },
    name: 'ProviderCrawlerShow',
    path: '/providers/:city/:zip/:name',
  },

  {
    component: PublicProviderShow,
    meta: { depth: 2, public: true },
    name: 'PublicProviderShow',
    path: '/providers/:providerId',
  },

  {
    component: BusinessShow,
    meta: {
      app_bar: true,
      depth: 10,
      page: 'provider/pages/business-settings',
      title: 'BusinessShow',
    },
    name: 'BusinessShow',
    path: '/business/settings',
    beforeEnter(_to, _from, next) {
      store.getters.showBusinessAdminPages() ? next() : next('/');
    },
  },

  {
    path: '/settings',
    redirect: '/business/settings',
  },

  {
    component: ProviderStaffShow,
    meta: {
      app_bar: true,
      depth: 11,
      title: 'ProviderStaffShow',
    },
    name: 'ProviderStaffShow',
    path: '/business/staff/:memberId',
    beforeEnter(_to, _from, next) {
      store.getters.showBusinessAdminPages() ? next() : next('/');
    },
  },

  {
    component: ProviderStaffIndex,
    meta: {
      app_bar: true,
      depth: 10,
      title: 'ProviderStaffIndex',
    },
    name: 'ProviderStaffIndex',
    path: '/business/staff',
    beforeEnter(_to, _from, next) {
      store.getters.showBusinessAdminPages() ? next() : next('/');
    },
  },

  {
    path: '/staff',
    redirect: '/business/staff',
  },

  {
    component: StudentIndex,
    meta: { depth: 3, page: 'provider/pages/enrollments' },
    path: '/students',
    children: [
      {
        component: EnrollmentIndex,
        name: 'EnrollmentIndex',
        meta: { depth: 4, page: 'provider/pages/enrollments' },
        path: '',
      },
      {
        meta: { depth: 5, page: 'provider/pages/attendance' },
        name: 'AttendanceIndex',
        path: 'attendance',
        component: AttendanceIndex,
      },
    ],
  },

  {
    component: SignOut,
    meta: {
      app_bar: true,
      depth: 10,
      title: 'Sign out',
    },
    name: 'SignOut',
    path: '/sign_out',
  },

  {
    component: ContactSubscriptions,
    name: 'Subscriptions',
    path: '/subscriptions',
    meta: { depth: 999, public: true, title: 'Subscriptions' },
  },

  {
    component: TermsAgreement,
    meta: {
      registration: true,
      title: 'Terms agreement',
    },
    name: 'TermsAgreement',
    path: '/terms_agreement',
  },

  {
    component: TourShow,
    name: 'TourShow',
    path: '/tours/:tourId',
    meta: {
      depth: 3,
      title: 'Tours',
    },
  },

  {
    component: WebpageShow,
    meta: {
      background: 'bg-white',
      public: true,
    },
    name: 'WebpageShow',
    path: '/pages/:webpageId',
  },

  {
    component: WebpageLanding,
    meta: {
      public: true,
    },
    name: 'Landing',
    path: '/',
  },

  {
    path: '/:pathMatch(.*)*',
    component: FallbackRouter,
    meta: {
      public: true,
    },
  },
];

export default createRouter({
  history: createWebHistory(window.PORTAL_BASE_URL_PATH),
  routes,
});
